import React from "react"
import { Box, Button, Grid, TextField, useTheme } from "@mui/material"
import Header from "components/Header"
import { useLocation } from "react-router-dom"
import axios from "axios"
import encrypt from "lib/encryption"
import { config } from "config"
import utill from "lib/utill"
import store from "state/store"
import * as XLSX from "xlsx"
 

const NewUser = () => {
  const theme = useTheme()
  const routeLocation = useLocation()
  const initialName = routeLocation.state?.name ?? ""

  const [form, setForm] = React.useState({
    user_name: initialName,
    phone: "",
  })

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // TODO: wire API call in a follow-up task
  }

  const handleNameChange = (event) => {
    setName(event.target.value)
  }

  const handlePhoneChange = (event) => {
    setPhone(event.target.value)
  }

  const [name, setName] = React.useState("")
  const [phone, setPhone] = React.useState("")
  const [isLoading, setIsLoading] = React.useState(false)
  const [kiosks, setKiosks] = React.useState([])
  // GET_HOST_KIOSK_LIST 결과를 지속 활용하기 위한 메모리 변수
  const kioskResultRef = React.useRef(null)
  const fileInputRef = React.useRef(null)
  const adminId = React.useMemo(() => utill.base64Decode(sessionStorage.getItem("x-a-d-i") ?? ""), [])
  const isSangmu = adminId === "sangmusushi"

  const [startDate, setStartDate] = React.useState(() => {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const startOfMonth = new Date(
      Date.UTC(currentYear, currentMonth, 1, 0, 0, 0)
    )
    startOfMonth.setUTCHours(startOfMonth.getUTCHours() + 9) // UTC+9 (한국 시간)
    return startOfMonth.toISOString()
  })

  const [endDate, setEndDate] = React.useState(() => {
    const today = new Date()
    today.setHours(23, 59, 59, 999) // 종료 시간을 23:59:59로 설정
    today.setUTCHours(today.getUTCHours() + 9)
    return today.toISOString()
  })
  
  const handleButtonClickExcel = () => {
    handleExcelAddClick()
  }

  const handleExcelAddClick = () => {
    if (isSangmu) {
      alert("권한이 없습니다.")
      return
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
      fileInputRef.current.click()
    }
  }

  const handleExcelFileChange = async (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return
    try {
      const arrayBuffer = await file.arrayBuffer()
      const workbook = XLSX.read(arrayBuffer, { type: "array" })
      const firstSheetName = workbook.SheetNames[0]
      const firstSheet = workbook.Sheets[firstSheetName]
      const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 })
      // 헤더 행을 동적으로 탐색: '핸드폰' 등 휴대폰 컬럼명이 들어있는 행 찾기
      const headerCandidates = ["핸드폰", "휴대폰", "전화번호", "전화", "phone", "phonenumber"]
      let headerRowIndex = -1
      for (let r = 0; r < rows.length; r += 1) {
        const row = rows[r] || []
        const found = row.some((cell) => headerCandidates.includes(String(cell ?? "").trim().toLowerCase()))
        if (found) {
          headerRowIndex = r
          break
        }
      }
      const headerRow = headerRowIndex >= 0 ? rows[headerRowIndex] : rows[0] || []
      const headers = (headerRow || []).map((v) => String(v ?? "").trim())
      console.log("업로드 파일 컬럼:", headers)

      const findPhoneIndex = () => {
        for (let i = 0; i < headerRow.length; i += 1) {
          const cell = String(headerRow[i] ?? "").trim().toLowerCase()
          if (
            cell === "핸드폰" ||
            cell === "휴대폰" ||
            cell === "전화번호" ||
            cell === "전화" ||
            cell === "phone" ||
            cell === "phonenumber"
          ) return i
        }
        return -1
      }
      const phoneColIndex = findPhoneIndex()
      if (phoneColIndex === -1) {
        alert("엑셀에서 휴대폰 컬럼을 찾을 수 없습니다.")
        return
      }

      const phones = rows
        .slice(headerRowIndex >= 0 ? headerRowIndex + 1 : 1)
        .map((r) => (r ? r[phoneColIndex] : undefined))
        .map((v) => (v == null ? "" : String(v).trim().replace(/-/g, "")))
        .filter((v) => v.length > 0)

      console.log("찾은 휴대폰 번호:", phones)

      await getCommuteListExcel(phones)
    } catch (err) {
      console.error("엑셀 읽기 오류", err)
    }
  }

  const handleSave = (e) => {
    e.preventDefault()
    if (isSangmu) {
      alert("권한이 없습니다.")
      return
    }
    const n = (name || "").trim()
    const p = (phone || "").trim()
    if (!n) {
      window.alert("이름을 입력해 주세요.")
      return
    }
    if (!p) {
      window.alert("휴대폰 번호를 입력해 주세요.")
      return
    }
    // kioskResultRef.current에서 hostLocationOid 값을 로그로 출력
    const resultObj = kioskResultRef.current
    var hostLocationOid = 100000000
    if (resultObj && typeof resultObj === "object") {
      const items = Array.isArray(resultObj.Item)
        ? resultObj.Item
        : Array.isArray(resultObj.items)
        ? resultObj.items
        : Array.isArray(resultObj.item)
        ? resultObj.item
        : []
      for (let i = 0; i < items.length; i += 1) {
        const item = items[i] || {}
        hostLocationOid = item.host_location_oid 
        updateForce_approveFacial(p, hostLocationOid)
        // console.log("hostLocationOid:", hostLocationOid)
      }
      alert("등록 되었습니다.")
      updateForce_BeaconRefresh(p, hostLocationOid)
    } else {
      console.log("kioskResultRef.current is empty")
    }
    // getCommuteListExcel()
  }

  const getCommuteListExcel = async (phones) => {
    try {
      if (isSangmu) {
        alert("권한이 없습니다.")
        return
      }
      if (!Array.isArray(phones) || phones.length === 0) {
        alert("처리할 휴대폰 번호가 없습니다.")
        return
      }

      // 키오스크 목록 순회하며 각 휴대폰 번호에 대해 승인 API 호출
      const resultObj = kioskResultRef.current
      const kiosksItems = resultObj && typeof resultObj === "object"
        ? (Array.isArray(resultObj.Item)
            ? resultObj.Item
            : Array.isArray(resultObj.items)
            ? resultObj.items
            : Array.isArray(resultObj.item)
            ? resultObj.item
            : [])
        : []
      if (!kiosksItems || kiosksItems.length === 0) {
        console.warn("키오스크 목록을 찾을 수 없습니다. 먼저 지점 목록을 불러오세요.")
        return
      }

      for (let pIdx = 0; pIdx < phones.length; pIdx += 1) {
        const phonenum = phones[pIdx]
        for (let i = 0; i < kiosksItems.length; i += 1) {
          const item = kiosksItems[i] || {}
          const hostLocationOid = item.host_location_oid
          try {
            // eslint-disable-next-line no-await-in-loop
            console.log("phonenum:", phonenum)
            console.log("hostLocationOid:", hostLocationOid)
            await updateForce_approveFacial(phonenum, hostLocationOid, true)
          } catch (e) {
            // continue others
          }
        }
        updateForce_BeaconRefresh(phonenum, 100000000)
      }
      alert("등록 되었습니다.")
      
    } catch (err) {
      console.error("엑셀 처리 오류", err)
    }
  }

  const authKeyEncD = encrypt(
    process.env.REACT_APP_AUTH_KEY,
    process.env.REACT_APP_PUBLIC_KEY
  )

  // 지점(키오스크) 리스트 조회 - 첫 진입 시 1회 호출
  React.useEffect(() => {
    getHostKioskList()
  }, [])

  // 조회된 지점 리스트 확인용 (필요 시 UI 연동)
  React.useEffect(() => {
    if (kiosks && kiosks.length > 0) {
      console.log("GET_HOST_KIOSK_LIST 응답:", kiosks)
      // 전체 resultObject의 key/value 확인
      const obj = kioskResultRef.current
      if (obj && typeof obj === "object") {
        Object.entries(obj).forEach(([key, value]) => {
          console.log(`resultObject.${key}:`, value)
        })
        // Item 배열이 있으면 각 원소의 key/value도 출력
        if (Array.isArray(obj.Item)) {
          obj.Item.forEach((item, idx) => {
            console.log(`Item[${idx}] ------------------`)
            Object.entries(item || {}).forEach(([k, v]) => {
              console.log(`  ${k}:`, v)
            })
          })
        }
      }
    }
  }, [kiosks])

  const getHostKioskList = async () => {
    const url = `${config.api || ""}/webservices/GeneralService.asmx`
    console.log("url:", url)
    const bodyJson = {
      request: {
        page_no: 1,
        name: "",
        host_oid: utill.base64Decode(sessionStorage.getItem("x-a-h-o") ?? ""),
      },
    }
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "GET_HOST_KIOSK_LIST",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/GetAdminDataJSON",
    }
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <GetAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </GetAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      const resultObject = JSON.parse(resultText)

      if (resultObject.Result != null) {
        const result = resultObject.Result
        if (result === "+OK") {
          // 전체 결과 객체를 메모리 변수에 저장 (리렌더링 없이 지속 사용 가능)
          kioskResultRef.current = resultObject
          setKiosks(resultObject.Item || [])
        } else {
          console.log("GET_HOST_KIOSK_LIST 처리 에러", resultObject)
        }
      } else {
        console.log("GET_HOST_KIOSK_LIST 응답 포맷 에러")
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  const updateForce_approveFacial = async (phonenum, hostLocationOid, suppressExistUserAlert = false) => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        phone_num: phonenum,
        host_location_oid: hostLocationOid,
      },
    }
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "FORCE_APPROVE_USER_FACIAL_ADMIN",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/UpdateAdminDataJSON",
    }
   
    // console.log("url:", url)
    // console.log("body.AuthKeyEncD:", body.AuthKeyEncD)
    // console.log("body.SessionIDEncN:", body.SessionIDEncN)
    // console.log("body.AdminOid:", body.AdminOid)
    // console.log("body.Mode:", body.Mode)
    // console.log("body.InputJSON:", body.InputJSON)

    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <UpdateAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </UpdateAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      console.log("response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", response?.data)
      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      let resultObject
      try {
        resultObject = JSON.parse(resultText)
      } catch (e) {
        console.error("Invalid JSON in <Result>:", resultText, e)
        alert("서버 응답 형식 오류입니다.")
        return
      }

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode
        if (result === "+OK") {
          if (resultCode === "-INVALID_USER") {
            alert("존재하지 않는 유저 입니다.")
          } else if (resultCode === "-INVALID_HOST") {
            alert("잘못된 접근 입니다.")
          } else if (resultCode === "-EXIST_USER") {
            if (!suppressExistUserAlert) {
              alert("이미 등록된 유저 입니다.")
            }
          } else {
            
          }
        }
      } else {
        
        console.log("resultObject:", resultObject.ResultCode)
        alert("저장 실패했습니다. 서버 오류입니다.")
      }
    } catch (error) {
      setIsLoading(false)
      if (error && error.response) {
        console.error("axios error response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", error.response.data)
      }
      console.error(error)
    }
  }

  const updateForce_BeaconRefresh = async (phonenum) => {
    const url = `https://gpass.ghostpass.ai/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        phone_num: phonenum,
      },
    }
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "FORCE_UPDATE_USER_STATUS",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/UpdateAdminDataJSON",
    }
    
    console.log("body.InputJSON:", body.InputJSON)
    
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <UpdateAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </UpdateAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      console.log("response.data (FORCE_UPDATE_USER_STATUS):", response?.data)
      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      let resultObject
      try {
        resultObject = JSON.parse(resultText)
      } catch (e) {
        console.error("Invalid JSON in <Result>:", resultText, e)
        console.log("서버 응답 형식 오류입니다.")
        return
      }

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode
        if (result === "+OK") {
          console.log("푸쉬 전송성공")
        }
      } else {
        console.log("resultObject:", resultObject.ResultCode)
        console.log("푸쉬 실패했습니다. 서버 오류입니다.")
      }
    } catch (error) {
      setIsLoading(false)
      if (error && error.response) {
        console.error("axios error response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", error.response.data)
      }
      console.error(error)
    }
  }
  
  return (
    <Box m="1.5rem 2.5rem">
      <Header title="사용자 추가" subtitle="새 사용자를 등록합니다." />
      <Box component="form" onSubmit={handleSave} mt={2}>
        <Grid container spacing={2}>
          <Grid item>
            <TextField 
              label="등록할 이름" 
              value={name}
              onChange={handleNameChange} sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }} 
            />
          </Grid>
          <Grid item>
            <TextField 
              label="등록할 휴대폰" 
              value={phone}
              onChange={handlePhoneChange} sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }} 
            />
          </Grid>
        </Grid>
        <Box display="flex" gap={2} mt={3} alignItems="center" flexWrap="nowrap">
          <Button type="submit" variant="contained" onClick={handleSave} disabled={isSangmu}>저장</Button>  
        </Box>
        {!isSangmu && (
          <Box display="flex" gap={2} mt={3} alignItems="center" flexWrap="nowrap">
            <Button type="button" variant="contained" onClick={handleExcelAddClick}>엑셀로 추가</Button>
            <input
              type="file"
              accept=".xlsx,.xls"
              ref={fileInputRef}
              onChange={handleExcelFileChange}
              style={{ display: "none" }}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
export default NewUser


